import React, { Component } from "react";
import ContentWrapper from "../../components/common/ContentWrapper.js";
import AdminTemplate from "../../components/admin/layouts/Template.js";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import ManageGrade from "./manage/ManageGrade.js";
import ManageIdType from "./manage/ManageIdType.js";
import ManageUserType from "./manage/ManageUserTypes.js";
import ManageRoles from "./manage/ManageRoles.js";
import ManageNodeGroup from "./manage/ManageNodeGroup.js";
import ManageEmail from "./manage/ManageEmail.js";
import ManageAddressType from "./manage/ManageAddressType.js";
import ManageCity from "./manage/ManageCity.js";
import ManageCountry from "./manage/ManageCountry.js";
import ManageProvince from "./manage/ManageProvince.js";
import ManageGender from "./manage/ManageGender.js";
//import ManageStatus from "./ManageStatus";
//import ManageStatusType from "./ManageStatusType";
import ManageTitle from "./manage/ManageTitle.js";
import ManageLimit from "./manage/ManageRegistrationLimit.js";
import ManageExpiration from "./manage/ManageRequestExpiration.js";
import ManageAnnouncementTopic from "./manage/ManageAnnouncementTopic.js";
import ManageUserAcceptTerms from "./manage/ManageUserAcceptTerms.js";
import "./Settings.css"
import config from "../../helper/config.js";
import { customerConstants } from "../../helper/constants.js";
import ManagePromoCodes from "./manage/ManagePromoCodes.js";
import ManageCurrencyTypes from "./manage/ManageCurrencyTypes.js";
import ManageCreditCategories from "./manage/ManageCreditCategories.js";
import ManageCreditPrices from "./manage/ManageCreditPrices.js";
import ManagePurchaseMethods from "./manage/ManagePurchaseMethods.js";
import ManageAppConfig from "./manage/ManageAppConfig.js";
import { HiBars3, HiXMark } from "react-icons/hi2";

const getCustomerFeatureFlag = () => {
  return config.customerConfigs.featureFlag;
};

let tabTextColor;
const customer = getCustomerFeatureFlag();
switch (customer) {
  case customerConstants.EXO_CUSTOMER1:
    tabTextColor = "var(--maincolor)";
    break;
  case customerConstants.EXO_CUSTOMER2:
    tabTextColor = "var(--maincolor-cmc)";
    break;
  default:
    tabTextColor = "var(--maincolor)";
    break;
}

class EdSiderManageSettings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: 0,
      screenWidth: window.innerWidth,
      isTabSectionVisible: false,
    };

    this.handleResize = this.handleResize.bind(this);
  }

  handleChange = (event, newValue) => {
    this.setState({ value: newValue, isTabSectionVisible: false });
  };

  componentDidMount() {
    window.addEventListener("resize", this.handleResize);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize);
  }

  handleResize() {
    this.setState({
      screenWidth: window.innerWidth,
    });
  }

  toggleTabSection = () => {
    this.setState((prevState) => ({
      isTabSectionVisible: !prevState.isTabSectionVisible,
    }));
  };

  closeTabSection = () => {
    this.setState({ isTabSectionVisible: false });
  };

  render() {
    const { value, screenWidth, isTabSectionVisible } = this.state;
    const isMobileView = screenWidth < 1000;

    const settingsTabs = (
      <Tabs
        orientation="vertical"
        variant="scrollable"
        value={value}
        onChange={this.handleChange}
        aria-label="Vertical tabs example"
        sx={{
          "& .MuiTab-root": {
            fontFamily: "Inter, sans-serif",
            textTransform: "unset",
            letterSpacing: "-0.4px",
            fontWeight: "600",
            alignItems: "start",
            whiteSpace: "pre-wrap",
          },
          "& .Mui-selected, & .Mui-selected.MuiTab-root": {
            color: tabTextColor + " !important",
          },
          borderRight: 1,
          borderColor: "divider",
        }}
        TabIndicatorProps={{
          style: {
            backgroundColor: tabTextColor,
          },
        }}
      >
        <Tab label="Manage Registration Settings" {...a11yProps(0)} />
        <Tab
          label="Manage Request Expiration Settings"
          {...a11yProps(1)}
        />
        <Tab label="Manage Grade" {...a11yProps(2)} />
        <Tab label="Manage Node Group" {...a11yProps(3)} />
        <Tab label="Manage Email" {...a11yProps(4)} />
        <Tab label="Manage Address Type" {...a11yProps(5)} />
        <Tab label="Manage Country" {...a11yProps(6)} />
        <Tab label="Manage Province" {...a11yProps(7)} />
        <Tab label="Manage City" {...a11yProps(8)} />
        <Tab label="Manage Gender" {...a11yProps(9)} />
        <Tab label="Manage title" {...a11yProps(10)} />
        <Tab label="Manage Announcement Topic" {...a11yProps(11)} />
        <Tab label="Manage Promo Codes" {...a11yProps(12)} />
        <Tab label="Manage User Privacy Policy, T&C" {...a11yProps(13)} />
        <Tab label="Manage ID Types" {...a11yProps(14)} />
        <Tab label="Manage User Types" {...a11yProps(15)} />
        <Tab label="Manage Roles" {...a11yProps(16)} />
        <Tab label="Manage App Config" {...a11yProps(17)} />
      </Tabs>
    );

    return (
      <AdminTemplate>
        <ContentWrapper>
          <Box
            className="system-settings-page"
            sx={{
              flexGrow: 1,
              bgcolor: "background.paper",
              display: "flex",
              height: "100%",
            }}
          >
            {!isMobileView && (
              <div className="system-settings-desktop-tabs">
                {settingsTabs}
              </div>
            )}
            <div className="system-settings-main">
              {isMobileView && (
                <div className="system-settings-mobile-toolbar">
                  <button
                    type="button"
                    className="settings-menu"
                    onClick={this.toggleTabSection}
                    aria-label="Open system settings menu"
                  >
                    <HiBars3 />
                  </button>
                </div>
              )}
              <div className="system-settings-panel-area">
                <TabPanel value={value} index={0}>
                  <ManageLimit />
                </TabPanel>
                <TabPanel value={value} index={1}>
                  <ManageExpiration />
                </TabPanel>
                <TabPanel value={value} index={2}>
                  <ManageGrade />
                </TabPanel>
                <TabPanel value={value} index={3}>
                  <ManageNodeGroup />
                </TabPanel>
                <TabPanel value={value} index={4}>
                  <ManageEmail />
                </TabPanel>
                <TabPanel value={value} index={5}>
                  <ManageAddressType />
                </TabPanel>
                <TabPanel value={value} index={6}>
                  <ManageCountry />
                </TabPanel>
                <TabPanel value={value} index={7}>
                  <ManageProvince />
                </TabPanel>
                <TabPanel value={value} index={8}>
                  <ManageCity />
                </TabPanel>
                <TabPanel value={value} index={9}>
                  <ManageGender />
                </TabPanel>
                <TabPanel value={value} index={10}>
                  <ManageTitle />
                </TabPanel>
                <TabPanel value={value} index={11}>
                  <ManageAnnouncementTopic />
                </TabPanel>
                <TabPanel value={value} index={12}>
                  <ManagePromoCodes />
                </TabPanel>
                <TabPanel value={value} index={13}>
                  <ManageUserAcceptTerms />
                </TabPanel>
                <TabPanel value={value} index={14}>
                  <ManageIdType />
                </TabPanel>
                <TabPanel value={value} index={15}>
                  <ManageUserType />
                </TabPanel>
                <TabPanel value={value} index={16}>
                  <ManageRoles />
                </TabPanel>
                <TabPanel value={value} index={17}>
                  <ManageAppConfig />
                </TabPanel>
              </div>
            </div>
          </Box>
        </ContentWrapper>

        {isMobileView && isTabSectionVisible && (
          <>
            <div
              className="system-settings-drawer-overlay"
              onClick={this.closeTabSection}
            />
            <aside className="system-settings-drawer">
              <div className="system-settings-drawer-header">
                <button
                  type="button"
                  className="system-settings-drawer-close"
                  onClick={this.closeTabSection}
                  aria-label="Close system settings menu"
                >
                  <HiXMark />
                </button>
              </div>
              <div className="system-settings-drawer-body">
                {settingsTabs}
              </div>
            </aside>
          </>
        )}
      </AdminTemplate>
    );
  }
}

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
      style={{ width: "100%" }}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    "aria-controls": `vertical-tabpanel-${index}`,
  };
}

const StandaloneSettingsSection = ({ children }) => (
  <AdminTemplate>
    {children}
  </AdminTemplate>
);

export const ManageCurrencyTypesPage = () => (
  <StandaloneSettingsSection>
    <ManageCurrencyTypes />
  </StandaloneSettingsSection>
);

export const ManageOneCreditPricesPage = () => (
  <StandaloneSettingsSection>
    <ManageCreditPrices />
  </StandaloneSettingsSection>
);

export const ManagePurchaseMethodsPage = () => (
  <StandaloneSettingsSection>
    <ManagePurchaseMethods />
  </StandaloneSettingsSection>
);

export const ManageCreditCategoriesPage = () => (
  <StandaloneSettingsSection>
    <ManageCreditCategories />
  </StandaloneSettingsSection>
);

export const ManageAppConfigurationsPage = () => (
  <StandaloneSettingsSection>
    <ManageAppConfig />
  </StandaloneSettingsSection>
);

export default EdSiderManageSettings;
